import { queryOptions } from '@tanstack/react-query';
import type { Config } from '@meeting-assistant/schemas';
import { getConfig } from '@/lib/api';

export const configQueryOptions = queryOptions<Config>({
  queryKey: ['config'],
  queryFn: getConfig,
  staleTime: Infinity,
  retry: false,
  throwOnError: false,
});
